import React from 'react'
import classNames from 'classnames'
import ContentColumn from './ContentColumn/ContentColumn'
import { ColumnsChildrenProps } from './Columns.d'

const TwoColumnContent = ({
  columnContents = [],
  textColor,
  textAlignment
}: ColumnsChildrenProps) => {
  const renderContents = (column: any) => {
    return column.children.map((content: any, i: number) => {
      return (
        <ContentColumn
          component={content}
          key={i}
          type={content.typeHandle}
          textColor={textColor}
        />
      )
    })
  }
  return (
    <>
      {columnContents.map((column: any, index: number) => {
        const exportClass = classNames(
          'col-span-4 md:col-span-3 lg:col-span-6 grid w-full',
          {
            'md:pl-10': index === columnContents.length - 1,
            'text-center justify-items-center': textAlignment === 'center',
            'text-left': textAlignment === 'left',
            'text-right': textAlignment === 'right',
            'order-none md:order-none':
              column.children[0].typeHandle === 'image',
            'order-1 md:order-none': column.children[0].typeHandle !== 'image'
          }
        )
        return (
          <div
            className={exportClass}
            key={index}
            data-testid='TwoColumnContent'
          >
            {renderContents(column)}
          </div>
        )
      })}
    </>
  )
}
export default TwoColumnContent
